var _excluded = ["intent", "title", "description", "duration", "hasCloseButton", "isShown", "onClose", "onRemove"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { css } from "@emotion/core";
import * as React from "react";
import Alert from "../Alert";
import { useAutoClose } from "../hooks";
import StackView from "../StackView";
import Text from "../Text";
import ToastTransition from "./ToastTransition";
import { jsx as ___EmotionJSX } from "@emotion/core";
var _ref = {
  name: "uw7k7s",
  styles: "pointer-events:all;"
};
export default function Toast(props) {
  var intent = props.intent,
      title = props.title,
      description = props.description,
      duration = props.duration,
      hasCloseButton = props.hasCloseButton,
      isShown = props.isShown,
      onClose = props.onClose,
      onRemove = props.onRemove,
      alertProps = _objectWithoutPropertiesLoose(props, _excluded);

  var _useAutoClose = useAutoClose(duration, onClose),
      startAutoCloseTimer = _useAutoClose[0],
      stopAutoCloseTimer = _useAutoClose[1];

  return ___EmotionJSX(ToastTransition, {
    unmountOnExit: true,
    "in": isShown,
    onExited: onRemove
  }, ___EmotionJSX(Alert, _extends({
    css: _ref,
    tier: intent || undefined,
    elevation: 10,
    onClose: hasCloseButton ? onClose : undefined,
    onMouseEnter: function onMouseEnter() {
      return stopAutoCloseTimer();
    },
    onMouseLeave: startAutoCloseTimer,
    fontSize: description == null ? "md" : "lg"
  }, alertProps), description == null ? title : ___EmotionJSX(StackView, {
    spacing: "xs"
  }, ___EmotionJSX(Text, null, title), ___EmotionJSX(Text, {
    fontFamily: "text",
    fontSize: "sm",
    lineHeight: "copy"
  }, description))));
}
Toast.defaultProps = {
  description: undefined,
  duration: 5,
  hasCloseButton: true,
  isShown: true
};